import script from "./Leadership.vue?vue&type=script&setup=true&lang=js"
export * from "./Leadership.vue?vue&type=script&setup=true&lang=js"

import "./Leadership.vue?vue&type=style&index=0&id=05419d21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05419d21"]])

export default __exports__